module.exports = __webpack_public_path__ + "static/media/feedbackIcon.f8235123.svg";